export const normalizeAddressId = (
  addressId: string | null | undefined
): string => {
  return (addressId || '').toLowerCase();
};
